// Stable test ids for QA / E2E.
//
// Phase V3 cleanup: recipient app retired — every `recipient*` /
// `withdraw*` / `emergency*` test id was deleted with its screen.
// If we ever need a recipient-side test surface again, it'll live on
// WhatsApp, not in this file.

export const HOME = {
    emergentLink: 'home-emergent-link',
};

export const T = {
    // Onboarding
    onboardSelectSender: 'onboard-sender',
    onboardSelectAgent: 'onboard-agent',

    // Login — Sender
    senderEmailTab: 'sender-email-tab',
    senderPhoneTab: 'sender-phone-tab',
    senderEmailInput: 'sender-email-input',
    senderPhoneInput: 'sender-phone-input',
    senderCountrySelect: 'sender-country-select',
    senderSendOtpBtn: 'sender-send-otp',
    senderOtpInput: 'sender-otp-input',
    senderVerifyBtn: 'sender-verify-btn',

    // Bottom navigation (sender only — recipient nav retired V3)
    navHome: 'nav-home',
    navFamily: 'nav-family',
    navSupport: 'nav-support',
    navActivity: 'nav-activity',
    navProfile: 'nav-profile',

    // Sender CTAs
    quickSendSupport: 'qa-send-support',
    quickAddFamily: 'qa-add-family',
    quickMakeRequest: 'qa-make-request',
    quickViewActivity: 'qa-view-activity',
    addFamilyBtn: 'add-family-btn',
    addFamilySave: 'add-family-save',
    newSupportSave: 'new-support-save',
    bridgeRequestBtn: 'bridge-request-btn',
    bridgeAmountInput: 'bridge-amount-input',
    bridgePurposeInput: 'bridge-purpose-input',
    bridgeSubmit: 'bridge-submit',
    bridgeAdvance: 'bridge-next-stage', // banned-terms:ok - identifier kept for back-compat, value renamed
    logoutBtn: 'logout-btn',
};
